import { useEffect, useRef } from "react";

export const PHYSIO_SAVE_CONTINUE = "continue";
export const PHYSIO_SAVE_CLOSE = "close";

export default function usePhysioScaleExternalSave({
  triggerSave,
  setTriggerSave,
  saveActionRef,
  op,
  onSave,
}) {
 
  const onSaveRef = useRef(onSave);
  onSaveRef.current = onSave;

  const savingRef = useRef(false);

  useEffect(() => {
    if (op) return;
    if (!triggerSave) return;
    if (savingRef.current) return;

    savingRef.current = true;
    const action =
      saveActionRef?.current === PHYSIO_SAVE_CLOSE
        ? PHYSIO_SAVE_CLOSE
        : PHYSIO_SAVE_CONTINUE;
    saveActionRef.current = PHYSIO_SAVE_CONTINUE;

 
    Promise.resolve()
      .then(() => onSaveRef.current(action))
      .catch(() => {
        /* Each scale reports its own failure; this only has to not get stuck. */
      })
      .finally(() => {
        savingRef.current = false;
        setTriggerSave?.(false);
      });
  }, [triggerSave, op, setTriggerSave, saveActionRef]);
}
